var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningThick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2297 15.01L11.9797 0.99C11.6197 0.37 10.9697 0 10.2597 0C9.54974 0 8.88974 0.37 8.52974 0.99L0.279739 15.01C-0.0902606 15.64 -0.0902606 16.39 0.269739 17.02C0.629739 17.65 1.27974 18.03 1.99974 18.03H18.4997C19.2297 18.03 19.8797 17.65 20.2397 17.02C20.5997 16.39 20.5997 15.64 20.2297 15.01ZM10.2597 12.78C10.9497 12.78 11.5097 13.34 11.5097 14.03C11.5097 14.72 10.9497 15.28 10.2597 15.28C9.56974 15.28 9.00974 14.72 9.00974 14.03C9.00974 13.34 9.56974 12.78 10.2597 12.78ZM9.25974 10.28V6.03C9.25974 5.48 9.70974 5.03 10.2597 5.03C10.8097 5.03 11.2597 5.48 11.2597 6.03V10.28C11.2597 10.83 10.8097 11.28 10.2597 11.28C9.70974 11.28 9.25974 10.83 9.25974 10.28Z",
    fill: "#8F6400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningThick);
export default __webpack_public_path__ + "static/media/warning-thick.0e85e3ac58f84c0dd949d83bfc69aedc.svg";
export { ForwardRef as ReactComponent };